import {api} from "../plugins/axios";
import {
    CarharttBanner,
    Content,
    ContentDetail,
    CustomerCenterButtonDto,
    CustomerCenterDto, CustomerMailRequest,
    Paged,
    TResponse,
    WorksTypeEnum,
    WorksWithUsDto,
    WorksWithUsGroupDto,
    WorkWithUsListParams
} from "../types/types";

export const getBanners = (type: 'MAIN' | 'JOURNAL') => {
    const params = {type}
    return api.get<TResponse<Paged<CarharttBanner>>>('/v1/banners/carhartt', {params})
}

export const getContents = (type: 'CARHARTT' | 'CARHARTT_JOURNAL', page?: number, size?: number) => {
    const params = {type, page, size: size || 1000}
    return api.get<TResponse<Paged<Content>>>('/v1/contents', {params})
}

export const getContentDetail = (contentId: number) => {
    return api.get<TResponse<ContentDetail>>(`/v1/contents/${contentId}`)
}


export const getWorksList = (params: WorkWithUsListParams) => {
    return api.get<TResponse<Paged<WorksWithUsDto>>>(`/v1/works-with-us`, {params})
}

export const getWorksDetail = (id: number) => {
    return api.get<TResponse<WorksWithUsDto>>(`/v1/works-with-us/${id}/detail`)
}

export const getWorksGroupList = (type: 'HEAD_LOGISTICS' | 'OFFLINE_STORE') => {
    return api.get<TResponse<WorksWithUsGroupDto[]>>(`/v1/works-with-us/${type}/group`)
}

export const getWorksTypeList = () => {
    return api.get<TResponse<WorksTypeEnum[]>>(`/v1/works-with-us/type`)
}

export const getCustomerCenterButtons = () => {
    const params = {
        site: 'CARHARTT', page: 0, size: 1000,
    }
    return api.get<TResponse<Paged<CustomerCenterButtonDto>>>(`/v1/customer-center/button`, {params})
}

export const getCustomerCenterDetail = (id: number) => {
    const url = `/v1/customer-center`
    const params = {id}
    return api.get<TResponse<CustomerCenterDto>>(url, {params})
}

export const postCustomerRequest = (request: CustomerMailRequest, files: File[]) => {
    const url = `/v1/customers/request`
    let formData = new FormData()
    for (let file of files) {
      formData.append(`files`, file);
    }
    formData.append(
      'request',
      new Blob([JSON.stringify(request)], {type: 'application/json'})
    );
    return api.post<TResponse<void>>(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
}
